/**
 * DD-3697: macOS hides overlay scrollbars until you scroll, so a short scroll area looks like
 * it has nothing more. Styling ::-webkit-scrollbar makes Chrome and Safari draw a permanent,
 * classic scrollbar. The standard scrollbar-width/-color would switch that styling off in
 * Chrome, so they apply only where ::-webkit-scrollbar is unsupported (Firefox).
 * Spread into an `sx` that also sets overflowY.
 */
export const alwaysVisibleScrollbar = {
    '&::-webkit-scrollbar': { width: 8 },
    '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(0, 0, 0, 0.04)', borderRadius: 4 },
    '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0, 0, 0, 0.35)', borderRadius: 4 },
    '@supports not selector(::-webkit-scrollbar)': {
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(0, 0, 0, 0.35) transparent',
    },
} as const;
